import './CartReminder.scss';
import Component from './CartReminder.js';
export default Component;
